import { MapPin } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const zones = [
  {
    title: "Villeurbanne (tous quartiers)",
    areas: "Charpennes, République, Gratte-Ciel, Cusset, Flachet, Laurent Bonnevay, Croix Luizet, Ferrandière, Maisons-Neuves, Perralière, Salengro, Saint-Jean, Buers, Tonkin, Zola, Tolstoï"
  },
  {
    title: "Lyon (arrondissements)",
    areas: "Lyon 1, 2, 3, 4, 5, 6, 7, 8, 9 • La Part-Dieu, La Villette, Montchat, Sans Souci/Dauphiné, Montplaisir, Grange Blanche, Guillotière"
  },
  {
    title: "Grand Lyon (métropole)",
    areas: "Bron, Vaulx-en-Velin, Caluire-et-Cuire, Meyzieu, Tassin-la-Demi-Lune, Oullins, Pierre-Bénite, Dardilly, Écully, Saint-Genis-Laval, Francheville, Saint-Priest"
  }
];

const Zones = () => {
  return (
    <section id="zones" className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Zones d'intervention Serrurier Villeurbanne</h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Interventions ultra rapides à Villeurbanne (tous quartiers) & métropole de Lyon
          </p>
          <a href="/zones-intervention" className="inline-block mt-4 underline underline-offset-4 decoration-2 text-secondary hover:text-primary font-medium">
            Voir tous les quartiers couverts →
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {zones.map((zone, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="flex items-start gap-3">
                  <div className="h-10 w-10 bg-secondary rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="h-5 w-5 text-secondary-foreground" />
                  </div>
                  <CardTitle className="text-lg leading-tight">{zone.title}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground leading-relaxed">{zone.areas}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Zones;
